// Posisi kapal di antara dua titik jejak.

function toMs(point) {
  return Number(point && point.timestamp) * 1000;
}

function lerp(a, b, t) {
  return a + (b - a) * t;
}

// Sudut lewat jalur terpendek: 350 -> 10 itu +20, bukan -340.
function lerpAngle(a, b, t) {
  const delta = ((((b - a) % 360) + 540) % 360) - 180;
  return (((a + delta * t) % 360) + 360) % 360;
}

// ~11 m; di bawah itu kapal dianggap diam dan heading GPS-nya cuma derau.
function isStationary(a, b) {
  return Math.abs(a.latLong[0] - b.latLong[0]) < 1e-4
    && Math.abs(a.latLong[1] - b.latLong[1]) < 1e-4;
}

function toPos(point) {
  return {
    lat: point.latLong[0],
    lng: point.latLong[1],
    heading: Number(point.heading) || 0,
  };
}

// Indeks titik terakhir yang waktunya <= target.
function segmentBefore(points, target) {
  let low = 0;
  let high = points.length - 1;
  while (low < high) {
    const mid = Math.ceil((low + high) / 2);
    if (toMs(points[mid]) <= target) low = mid;
    else high = mid - 1;
  }
  return low;
}

export function timeRange(points) {
  if (!Array.isArray(points) || points.length < 2) return null;
  const start = toMs(points[0]);
  const end = toMs(points[points.length - 1]);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return null;
  return { start, end };
}

export function positionAt(points, ms) {
  if (!Array.isArray(points) || points.length === 0) return null;
  const target = Number(ms);
  if (!Number.isFinite(target)) return null;

  const first = toMs(points[0]);
  const last = toMs(points[points.length - 1]);
  if (!Number.isFinite(first) || !Number.isFinite(last)) return null;
  if (target <= first) return toPos(points[0]);
  if (target >= last) return toPos(points[points.length - 1]);

  const i = segmentBefore(points, target);
  const a = points[i];
  const b = points[i + 1];
  if (!b) return toPos(a);

  const span = toMs(b) - toMs(a);
  const t = span > 0 ? (target - toMs(a)) / span : 0;
  return {
    lat: lerp(a.latLong[0], b.latLong[0], t),
    lng: lerp(a.latLong[1], b.latLong[1], t),
    heading: isStationary(a, b)
      ? Number(a.heading) || 0
      : lerpAngle(Number(a.heading) || 0, Number(b.heading) || 0, t),
  };
}

export function pathUpTo(points, ms) {
  const pos = positionAt(points, ms);
  if (!pos) return [];
  const target = Number(ms);
  const path = points.filter((point) => toMs(point) <= target).map((point) => point.latLong);
  if (!path.length) path.push(points[0].latLong);
  const tail = path[path.length - 1];
  if (tail[0] !== pos.lat || tail[1] !== pos.lng) path.push([pos.lat, pos.lng]);
  return path;
}
